import { render, staticRenderFns } from "./CommonListTextAnswer.vue?vue&type=template&id=23b7b610&scoped=true&"
import script from "./CommonListTextAnswer.vue?vue&type=script&lang=js&"
export * from "./CommonListTextAnswer.vue?vue&type=script&lang=js&"
import style0 from "./CommonListTextAnswer.vue?vue&type=style&index=0&id=23b7b610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7b610",
  null
  
)

export default component.exports